const MAX_LENGTH = 10;

export function formatDisplayName(
  name?: string | null,
  email?: string | null,
): string | undefined {
  const normalizedName = name?.trim();
  if (normalizedName) {
    const parts = normalizedName.split(/\s+/).filter(Boolean);
    const firstName = parts[0] ?? '';
    const lastName = parts.length > 1 ? parts[parts.length - 1] : '';

    const truncatedFirstName =
      firstName.length > MAX_LENGTH
        ? `${firstName.slice(0, MAX_LENGTH)}...`
        : firstName;

    if (!lastName) {
      return truncatedFirstName || undefined;
    }

    return `${truncatedFirstName} ${lastName[0]}.`;
  }

  const normalizedEmail = email?.trim();
  if (!normalizedEmail) {
    return undefined;
  }

  return normalizedEmail.length > MAX_LENGTH
    ? `${normalizedEmail.slice(0, MAX_LENGTH)}...`
    : normalizedEmail;
}
